import { Stack } from "@mantine/core"

import { CONFIGURATIONS_SETTINGS_SCOPE } from "@tfg/types/schemas/communication-studio/configurationParameters"
import { ContentFilteringProps } from "@tfg/types/types/communication-studio/configurations.types"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { useGetConfigurationsByScope } from "~/gen/api"
import { StandardsConfigurations } from "~/pages/Brand/CommunicationStudio/Content/StandardsConfiguratinons"
import { useComponentCreation } from "~/pages/Brand/CommunicationStudio/contexts/componentCreation/useComponentCreation"
import { useAuth } from "~/store/auth-context"

export const ContentFiltering = () => {
  const { productSheetGroupId } = useComponentCreation()
  const { user } = useAuth()
  const clientId = user?.organization?.id

  const query = useGetConfigurationsByScope(productSheetGroupId, {
    scope: CONFIGURATIONS_SETTINGS_SCOPE.CONTENT_FILTERING,
  })
  if (!clientId) return <div>No client id</div>

  return (
    <DataFetchWrapper query={query}>
      {({ data }) => {
        return (
          <Stack>
            <StandardsConfigurations
              configuration={data?.data.configurations as ContentFilteringProps}
              clientId={clientId}
            />
          </Stack>
        )
      }}
    </DataFetchWrapper>
  )
}
